import type { YearValue } from "@/lib/data/types";
import { CHART_RANGES, type ChartRangeLabel } from "@/components/charts/range-selector";

/**
 * Filtert eine Jahres-Zeitreihe auf die letzten N Jahre relativ zum juengsten Datenpunkt.
 * Bei jaehrlicher Granularitaet ergibt "1J" bewusst genau einen Datenpunkt - das ist
 * korrekt, kein Sonderfall. Ein frueherer "mindestens 2 Punkte, sonst alles anzeigen"-
 * Fallback sollte nur eine leere Auswahl verhindern, hat dadurch aber "1J" bei jaehrlichen
 * Daten immer auf die volle Historie zurueckfallen lassen - der Cutoff schliesst das
 * juengste Jahr per Konstruktion immer mit ein, ein leeres Ergebnis ist also ausgeschlossen.
 */
export function filterYearRange(series: YearValue[], range: ChartRangeLabel): YearValue[] {
  const config = CHART_RANGES.find((r) => r.label === range);
  if (!config || config.years === null || series.length === 0) return series;
  const maxYear = Math.max(...series.map((v) => v.year));
  const cutoff = maxYear - config.years + 1;
  return series.filter((v) => v.year >= cutoff);
}
